// TODO: Either refactor or change with MarkupEditor when migrating to Vue
export default class ReleaseNotesComponent {
	constructor() {
		this.template = require('./jf-release-notes.view.html');
		this.controller = ReleaseNotesController;
		this.bindings = {
			parent: '<',
			resource: '<',
			resourceParams: '<',
			multiMode: '<',
			releaseNotes: '<?'
		};
	}
};

ReleaseNotesComponent.META = {
	name: 'jfReleaseNotes'
};

class ReleaseNotesController {
	constructor() {
		this.data = [];
	}

	$onInit() {
		this.multiMode = this.multiMode !== false;
        this.data = this.releaseNotes;
	}

	onMultiModeStateChange() {
		_.assign(this.resourceParams, {
			release_notes_displayed: this.parent.releaseNotesLevel
		});

		this.resource.changeReleaseNotesLevel(this.resourceParams, () => {
			this.loadReleaseNotes();
		});
	}

	loadReleaseNotes() {
		return this.resource.getReleaseNotes(this.resourceParams).$promise.then((response) => {
			this.data = response;
		});
	}

	isCheckboxVisible() {
		return this.multiMode && this.parent.hasWritePermission;
	}

	save(item) {
		let extendedRequestParams = _.clone(this.resourceParams);
		_.assign(extendedRequestParams, item.build());

		this.resource.saveReleaseNotes(extendedRequestParams, {
			content: extendedRequestParams.content,
			contentType: extendedRequestParams.contentType
		});
	}

	getVersionLabel(item) {
		return item.version && item.version.name ? `Version: ${item.version.name}` : '';
	}

	isEmptyUneditableReleaseNotesList() {
		return this.data.releaseNotes.length === 1 &&
			this.data.releaseNotes[0].content === '' &&
			!this.data.releaseNotes[0].hasWritePermission;
	}
}

ReleaseNotesController.$inject = [];




// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-release-notes/jf-release-notes.component.js